import type { AttachmentFileList } from 'owa-attachment-file-types';
import type { AttachmentFullViewState } from 'owa-attachment-full-data';
import type {
    AttachmentType,
    AttachmentWellViewState,
    CreateAttachmentsProperties,
    OnAttachmentCreatedCallback,
} from 'owa-attachment-well-data';
import getAttachmentFullViewStateById from 'owa-attachment-well-data/lib/utils/getAttachmentFullViewStateById';
import replaceAttachment from 'owa-attachment-well-data/lib/utils/replaceAttachment';
import type { ClientAttachmentId, ClientItemId } from 'owa-client-ids';
import { FilePickerAction } from 'owa-filepicker';
import type { SonoraFile } from 'owa-editor-sonora-types';
import { convertClassicToCloudyForSonoraSuggestion } from './convertClassicToCloudyForSonoraSuggestion';
import createAttachmentFileFromSonoraSuggestion from './createAttachmentFileFromSonoraSuggestion';

export default function attachFilesForSelectedAction(
    sonoraItem: SonoraFile,
    action: FilePickerAction,
    attachmentWellViewState: AttachmentWellViewState,
    createAttachmentsCallback: (
        files: AttachmentFileList,
        createAttachmentsProperties: CreateAttachmentsProperties,
        onAllAttachmentsProcessed?: (attachmentId: ClientAttachmentId) => void,
        onAttachmentCreatedCallback?: OnAttachmentCreatedCallback
    ) => void
): void {
    const attachmentFile = createAttachmentFileFromSonoraSuggestion(sonoraItem);
    switch (action) {
        case FilePickerAction.Attach:
            createAttachmentsCallback([attachmentFile], {
                isInline: false,
                isHiddenInline: false,
                shouldShare: false,
            });
            break;
        case FilePickerAction.Share:
            // Todo: add support to upload and share.
            const onAttachmentCreatedCallback = (
                parentItemId: ClientItemId,
                attachmentId: ClientAttachmentId,
                attachment: AttachmentType
            ) => {
                const attachmentViewState = getAttachmentFullViewStateById(
                    attachmentWellViewState,
                    attachmentId
                );
                const replaceAttachmentHandler = (
                    attachmentFullViewState: AttachmentFullViewState,
                    attachmentType: AttachmentType,
                    isReadOnly: boolean,
                    uploadCompleted: boolean
                ) => {
                    replaceAttachment(
                        attachmentWellViewState /* AttachmentWellViewState */,
                        attachmentFullViewState /* AttachmentFullViewState */,
                        attachmentType /* AttachmentType */,
                        false /* isReadOnly */,
                        true /* uploadCompleted */
                    );
                };
                convertClassicToCloudyForSonoraSuggestion(
                    attachmentViewState,
                    parentItemId,
                    replaceAttachmentHandler
                );
            };

            createAttachmentsCallback(
                [attachmentFile],
                {
                    isInline: false,
                    isHiddenInline: false,
                    shouldShare: false,
                },
                undefined /* onAllAttachmentsProcessed */,
                onAttachmentCreatedCallback
            );
            break;
        case FilePickerAction.InsertAsLink:
            // Todo: add support to upload and insert as a link.
            break;
        default:
            break;
    }
}
